import "./SubcontractingCompany.scss";
import InfoContext from "pages/InfoContext";
import { Typography } from "core/typography/Typography";
import { useContext } from "react";
import { FormattedMessage } from "react-intl";
import {
  renderFirstName,
  renderInputEmail,
  renderInputNationalityIds,
  renderLastName,
} from "../CommonInputs";
import {
  SUBCONTRACTING_COMPANY_FORM_LABELS,
  SUBCONTRACTING_COMPANY_FORM_PLACEHOLDERS,
} from "constants/forms";
import PropTypes from "prop-types";

const ContactCompanyInfoForm = ({
  control,
  errors,
  readOnly,
  register,
  setValue,
  watch,
  cellHighlight,
}) => {
  const { dataCountry, lang, setCode, setStatus, slug } =
    useContext(InfoContext);

  return (
    <div className="contact-compagny-info">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="contact_company"
            defaultMessage="Contact Compagnie"
          />
        }
      />
      <div className="block-1">
        <div className="line-1">
          <div
            className={`cell-padding ${
              !watch("first_name") && cellHighlight && "errorCellColor"
            }`}
          >
            {renderFirstName({
              control,
              errors,
              label: SUBCONTRACTING_COMPANY_FORM_LABELS.first_name,
              placeholder: SUBCONTRACTING_COMPANY_FORM_PLACEHOLDERS.first_name,
              readOnly,
              register,
              name: "accounting_contact_first_name",
            })}
          </div>
          <div
            className={`cell-padding ${
              !watch("last_name") && cellHighlight && "errorCellColor"
            }`}
          >
            {renderLastName({
              control,
              errors,
              label: SUBCONTRACTING_COMPANY_FORM_LABELS.last_name,
              placeholder: SUBCONTRACTING_COMPANY_FORM_PLACEHOLDERS.last_name,
              readOnly,
              register,
              name: "accounting_contact_last_name",
            })}
          </div>
        </div>
        <div className="line-2">
          <div
            className={`cell-padding ${
              !watch("accounting_contact_email") &&
              cellHighlight &&
              "errorCellColor"
            }`}
          >
            {renderInputEmail({
              control,
              errors,
              label:
                SUBCONTRACTING_COMPANY_FORM_LABELS.accounting_contact_email,
              placeholder:
                SUBCONTRACTING_COMPANY_FORM_PLACEHOLDERS.accounting_contact_email,
              readOnly,
              register,
              name: "accounting_contact_email",
              errorMessage:
                errors?.["accounting_contact_email"]?.message || null,
              copyEmail: slug,
              setCode,
              setStatus,
            })}
          </div>
          <div
            className={`cell-padding ${
              watch("nationality_id").length === 0 &&
              cellHighlight &&
              "errorCellColor"
            }`}
          >
            {renderInputNationalityIds({
              control,
              errors,
              label: SUBCONTRACTING_COMPANY_FORM_LABELS.nationality,
              nationalities: dataCountry,
              placeholder: SUBCONTRACTING_COMPANY_FORM_PLACEHOLDERS.nationality,
              lang,
              readOnly,
              register,
              value: watch("nationality", []),
              setValue,
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCompanyInfoForm;

ContactCompanyInfoForm.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  cellHighlight: PropTypes.bool,
};
